export default "__VITE_ASSET__qy8T9Ly5__"